import type { TFunction } from "i18next";
import { REPORT_QUERY_MAX_LENGTH } from "./ReportNameModal";

export const reportSaveBlockedReason = (t: TFunction, query: string, listFailedToLoad: boolean): string | undefined =>
  listFailedToLoad
    ? String(t("The list has to load before it can be saved as a report."))
    : query.replace(/^\?/, "").length > REPORT_QUERY_MAX_LENGTH
      ? String(t("This list has too many filters or columns to be saved as a report. Remove some, then try again."))
      : undefined;
